<template>
    <div class="register-step1 register-section">
        <Form class="pop-common-form" :form="registerForm" @submit="handleSubmit">
            <FormItem class="form-item" label="手机号" :colon="false" v-bind="formItemLayoutCenter" hasFeedback>
                <Input v-decorator="['phone',
                {
                    rules: rules.phone,
                }
                ]"
                placeholder="请输入您的手机号码" maxLength=11
                />
                <div class="form-help" v-show="show"><img src="../../../../assets/images/icon-notice.png">手机号需唯一，若已经注册请直接<router-link :to="{name: isLeyou? 'lylogin' :'login'}">登录</router-link></div>
            </FormItem>
            <Code :identity.sync="identity" :appCode.sync="appCode" :appServiceCode.sync="appServiceCode" />
            <FormItem v-bind="tailFormItemLayout">
                <Button type="primary" html-type="submit" :disabled="isDisable">下一步</Button>
            </FormItem>
        </Form>
    </div> 
</template>
<script>
import { mapMutations, mapActions } from 'vuex'
import { Form, Input, Button } from 'ant-design-vue'
import FormUtil from '@utils/form'
import Code from '@components/verifyCode'
import { Base64 } from 'js-base64'
import FormMix from '../../formMixins'

export default {
    data() {
        return {
            // form: this.$form.createForm(this, {
            //     onFieldsChange: (_, changedFields) => {
            //         const values = this.registerForm.getFieldsValue()
            //         this.isDisable = Object.keys(values).some(v => !values[v])
            //     },
            // }),
            step: 1,
            // show: true,
            identity: '',
            appCode: '',
            appServiceCode: '',
            form: {},
            isLeyou:  /leyou/.test(window.location.hostname)
        }
    },
    mixins: [FormUtil, FormMix],
    methods: {
        ...mapMutations('register', ['setStepId', 'setRegInfo']),
        async validatePhone(rule, value, cb) {
            // this.show = false
            // 校验唯一性
            if (value && value.length === 11) {
                const json = await this.validPhone(value)
                if (json) {
                    cb('手机号已经被注册')
                }
            }
            cb()
        },
        handleSubmit(e) {
            e.preventDefault()
            this.registerForm.validateFields(async (error, values) => {
                if (!error) {
                    const json = await this.$store.dispatch('checkPicCode', {
                        identity: this.identity,
                        appCode: this.appCode,
                        appServiceCode: this.appServiceCode,
                        verifyCode: Base64.encode(values['code']),
                        needBase64: false
                    })
                    if (json && json.code * 1 === 1) {
                        this.setRegInfo({phone: values.phone})
                        this.setStepId(2)
                    } else {
                        this.$message.error(json.msg || '系统异常');
                    }
                }
                return;
            });
        }
    },
    components: {
        Form,
        FormItem: Form.Item,
        Input,
        Button,
        Code
    }
}
</script>

<style lang="scss">
    .register-step1 {
        .ant-form-item-children {
            display: flex;
        }

        input {
            width: 260px;
            height: 38px;
        }

        .ant-btn-primary {
            width: 260px;
            background: #1C7AE5;
            border-radius: 2px;
            font-size: 14px;
            color: #FFFFFF;
        }

        .ant-btn-default.noraml-bt {
            margin-left: 20px;
            height: 38px;
            font-size: 14px;
            border-radius: 2px;
        }

        .ant-form-item {
            margin-bottom: 20px;
        }
    }
</style>
<style lang="scss" scoped>

</style>
